import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import BrandBlogArticlePage from './BrandBlogArticlePage';

export default function BlogArticlePage() {
  return (
    <>
      <Navbar />
      <BrandBlogArticlePage
        publisher="沐燁文化"
        brandName="沐燁文化"
        englishName="MOYA"
      />
      <Footer />
    </>
  );
}
